import {Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';
import {Observable} from "rxjs";

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(){

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(localStorage.getItem('token'))
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
        
      },
      withCredentials:true

    });

    console.log(req)

    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/interceptor.service.ts